import { NgModule } from '@angular/core';
import { GetControlPipe } from './get-control.pipe';

@NgModule({
  declarations: [GetControlPipe],
  exports: [GetControlPipe],
})
export class PipesModule {}
